import React from 'react';
import InputField from '../../../../../FormControl/input/InputField';
import Typography from '@mui/material/Typography';
import { Chip, Divider } from '@mui/material';
import SelectCurriculum from '../../SelectCustom/SelectCurriculum';
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField';

const FormSpecialCircumstances = ({ form = {}, errors = {}, onChange, type, curriculumList = [] }) => {
  const currentCurriculum = curriculumList?.find((item) => item._id === form?.curriculumId);
  return (
    <>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Curriculum
      </Typography>
      <div className='col-span-3'>
        <SelectCurriculum
          id='curriculum-level'
          name='curriculumId'
          value={form?.curriculumId}
          onChange={(e) => onChange('curriculumId', e.target.value)}
          error={errors?.curriculumId}
          isPreview={type === 'preview'}
        />
      </div>
      <Divider className='col-span-full' />

      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Code
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.code}</Typography>
        ) : (
          <InputField
            id='code'
            name='code'
            value={form.code}
            error={errors?.code}
            helperText={errors?.code}
            onChange={(e) => onChange('code', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Name
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.name}</Typography>
        ) : (
          <InputField
            id='name'
            name='name'
            value={form.name}
            error={errors?.name}
            helperText={errors?.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Position
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.position}</Typography>
        ) : (
          <InputField
            id='position'
            name='position'
            value={form.position}
            error={errors?.position}
            helperText={errors?.position}
            onChange={(e) => onChange('position', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Description
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.description}</Typography>
        ) : (
          <InputField
            id='description'
            name='description'
            value={form.description}
            error={errors?.description}
            helperText={errors?.description}
            onChange={(e) => onChange('description', e.target.value)}
            fullWidth
            multiline={true}
          />
        )}
      </div>
    </>
  );
};

export default FormSpecialCircumstances;
